/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Summary_MarkersInputs */



/**
* | output |
* | --- |
* | "Markers published." |
*
* @param {Iconik_Publish_Summary_MarkersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_summary_markers = /** @type {((inputs?: Iconik_Publish_Summary_MarkersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Summary_MarkersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Markers published.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Markers published.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Markers published.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Markers published.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Markers published.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Markers published.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Markers published.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Markers published.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Markers published.")
	return /** @type {LocalizedString} */ ("Markers published.")
});